/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { FunctionComponent } from 'react';

import { GridProps } from './GridProps';

import './Grid.scss';

const Grid: FunctionComponent<GridProps> = (props): JSX.Element => {
    const gridStyle: React.CSSProperties = {
        display: 'grid',

        // Flexible column sizing - uses 1fr for equal distribution or auto for content-based
        gridTemplateColumns: props.columns ? `repeat(${props.columns}, 1fr)` : 'auto',

        // Rows auto-size based on content height
        gridAutoRows: 'min-content',

        // Gap handling - use combined gap if provided, otherwise individual gaps
        gap: props.gap,
        columnGap: !props.gap ? props.horizontalGap : undefined,
        rowGap: !props.gap ? props.verticalGap : undefined,

        // Padding with default fallback
        padding: props.padding || undefined,
    };

    return (
        <div className={`grid-container ${props.className || ''}`} style={gridStyle}>
            {props.children}
        </div>
    );
};

export default Grid;
